import { AccessControl } from "accesscontrol";
import { useAccount } from "./useAccount";

export function useAccessControl() {
    const account = useAccount();
    return (new AccessControl(
        account.capabilities?.grant
        || [{ role: 'user', resource: 'default', action: 'create:own', attributes: '*' }]
    ));
}